import { Armour, Equipment, Item, Unit } from '../models';

export const itemModifiesArmor = (item: Item) => {
    if (item.mod?.[0]?.type === 'diminishing' || item.mod?.[0]?.type === 'addicted') {
        return false;
    }
    const effect = item.mod?.[0]?.armour?.mod;
    return effect && Object.keys(effect).length > 0;
};

export const itemSetsArmor = (item: Equipment) => {
    if (item.mod?.[0]?.type === 'diminishing' || item.mod?.[0]?.type === 'addicted') {
        return false;
    }
    const effect = item.mod?.[0]?.armour?.replace;
    return effect && Object.keys(effect).length > 0;
};

export const canNewArmorBeEquipped = (unit: Unit, item: Equipment) => {
    const equippedArmor = unit.derived.equipment.filter((e) => e.equipped && (itemSetsArmor(e) || itemModifiesArmor(e)));
    if (equippedArmor.length === 0) {
        return true;
    }
    if (itemSetsArmor(item) && item.type === 'Power Armor') {
        return !equippedArmor.find((e) => e.type === 'Power Armor');
    }

    if (itemSetsArmor(item)) {
        return !equippedArmor.find(itemSetsArmor);
    }

    if (itemModifiesArmor(item)) {
        return !equippedArmor.find((e) => itemModifiesArmor(e) && e.type === item.type);
    }

    return null;
};

export const getArmourDisplayVal = (val: number) => {
    if (val === 0) {
        return '-';
    }

    if (val === -1) {
        return 'X';
    }
    return val?.toString();
};

export const getFullArmourDisplayVal = (unit: Unit, key: 'physical' | 'energy' | 'radiation') => {
    const val = unit.derived?.armour[key];

    if (val === 0) {
        return '-';
    }

    if (val === -1) {
        return 'X';
    }

    const hardVal = unit.derived?.armour[key + '_hard'];
    if (hardVal) {
        return `${val}+${hardVal}`;
    }

    return '' + val;
};
